
import { Box } from "@mui/material";
import { PDFDownloadLink, PDFViewer } from "@react-pdf/renderer";
import { Page, Text, View, Document, StyleSheet } from "@react-pdf/renderer";
const styles = StyleSheet.create({
    page: {
        flexDirection: "row",
        backgroundColor: "#E4E4E4"
    },
    section: {
        margin: 10,
        padding: 10,
        flexGrow: 1
    }
});

export default function Pdf() {

    return (
        <Box component="main" sx={{ flexGrow: 1, p: 5, height: '100vh', overflow: 'auto' }}>
            <PDFDownloadLink
                document={<DocumentPdf />}
                fileName="movielist.pdf"
                style={{
                    textDecoration: "none",
                    padding: "10px",
                    color: "#4a4a4a",
                    backgroundColor: "#f2f2f2",
                    border: "1px solid #4a4a4a"
                }}
            />
            <PDFViewer style={{ height: "100%", width: "100%" }}>
                <DocumentPdf />
            </PDFViewer>
        </Box>
    )



}


function DocumentPdf() {

    const dados = JSON.parse(localStorage.getItem("PreviewPDFFilter"));

    dados.map(el => {

        if (el.CNPJ.length > 11) {
            el.CNPJ = el.CNPJ.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5")
        } else {

            el.CNPJ = el.CNPJ.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
        }

    })

    console.log(dados);

    const a = dados.length / 33;
    const numberRows = Math.ceil(a);

    var firstArr = [];
    const qtdRows = [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
    ];
    for (let i = 0; i < numberRows; i++) {
        firstArr.push("");
    }

    if (dados.length == +1) {
        qtdRows.pop()
    }


    return (

        <Document>
            {dados.length > 0 &&
                firstArr.map((t, i) => {
                    return (
                        <Page size="A4" orientation="landscape" style={styles.page} key={i}>
                            <View style={{
                                flex: 1,

                            }}>
                                <Table>
                                    <RowHeader />
                                    {qtdRows.map((x, j) => {
                                        var position = i * 27 + j;
                                        if (dados.length > position) {
                                            console.log("aqui");
                                            return (
                                                <RowTable key={j}>
                                                    {/* <CellHeaderTable>
                                                        CNPJ/CPF Cliente/Devedor
                                                    </CellHeaderTable> */}
                                                </RowTable>
                                            )
                                        }
                                    })}
                                </Table>
                                <View style={{
                                    backgroundColor: "blue",
                                    height: "100px",
                                    width: "80px"
                                }}>

                                </View>
                            </View>
                        </Page>
                    );
                })}
        </Document>
    )
}

function Table({ children }) {
    return (
        <View style={{
            // backgroundColor: "red",
            height: "100%",
            width: "100%",
            border: "1px solid rgb(1, 167, 225)"
        }}>
            {children}
        </View>
    )
}

function RowTable({ children }) {
    return (
        <View >
            {children}
        </View>
    )
}

function CellHeaderTable({ children }) {
    return (
        <View style={{
            borderWidth: '0.5px 1.5px',
            borderStyle: "solid",
            borderImage: "initial",
            borderColor: "rgb(1, 167, 225)",
            flexBasis: "0px",
            flexGrow: 1,
            maxWidth: "100%",
            maxHeight: "100%",
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
        }}>
            <Text style={{
                fontWeight: "bold",
                paddingBlock: "4px",
                backgroundColor: "#EAEDF5",
                border: 1.5,
                borderColor: "#01A7E1",
                padding: "3px",
                fontSize: "8px",

            }}>
                {children}
            </Text>
        </View>
    )
}

function RowHeader({ children }) {
    return (
        <View style={{
            display: "flex",
            flexDirection: "row",
            backgroundColor: "red"
        }}>
            <CellHeaderTable>
                CNPJ/CPF Cliente/Devedor
            </CellHeaderTable>
            <CellHeaderTable>
                Cliente/Devedor
            </CellHeaderTable>
            <CellHeaderTable>
                Contrato
            </CellHeaderTable>
            <CellHeaderTable>
                Estágio
            </CellHeaderTable>
            <CellHeaderTable>
                Motivo
            </CellHeaderTable>
            <CellHeaderTable>
                Entrada
            </CellHeaderTable>
            <CellHeaderTable>
                Título
            </CellHeaderTable>
            <CellHeaderTable>
                Vencimento
            </CellHeaderTable>
            <CellHeaderTable>
                Valor Original
            </CellHeaderTable>
            <CellHeaderTable>
                Saldo
            </CellHeaderTable>
            <CellHeaderTable>
                Acordo
            </CellHeaderTable>
            <CellHeaderTable>
                Id do Acordo
            </CellHeaderTable>
            <CellHeaderTable>
                Id do Acordo
            </CellHeaderTable>
        </View>
    )
}